import { HttpEvent, HttpHandlerFn, HttpRequest } from '@angular/common/http';
import { inject } from '@angular/core';
import { CustomAlertService } from 'app/modules/shared/services/alert.service';
import { catchError, Observable, throwError } from 'rxjs';

import { quotaErrorMessage } from './quota-error.util';

/**
 * Shows a subscription limit rejection (tokens per day/month, storage, agents, data sources) once,
 * for every endpoint, instead of depending on each caller to handle its own error. The alert
 * service drops a repeat of the same message, so callers that also show it do not stack toasts.
 */
export const quotaErrorInterceptor = (
    req: HttpRequest<unknown>,
    next: HttpHandlerFn
): Observable<HttpEvent<unknown>> => {
    const alert = inject(CustomAlertService);
    return next(req).pipe(
        catchError((error) => {
            const message = quotaErrorMessage(error);
            if (message) {
                alert.failedMessage(message);
            }
            return throwError(() => error);
        })
    );
};
